import { api } from "@/lib/api-client";
import type { Paginated } from "../agents/api";

export type WhatsAppConversation = {
  id: string;
  customer_wa_id: string;
  customer_number: string;
  customer_name: string;
  business_number: string;
  agent_name: string | null;
  ai_enabled: boolean;
  last_message_at: string | null;
  last_message_preview: string;
  unread_count: number;
  created_at: string;
};

export type WhatsAppChatMessage = {
  id: string;
  direction: "inbound" | "outbound";
  sender: "customer" | "ai" | "human";
  message_type: string;
  body: string;
  media_url: string;
  media_mime: string;
  status: "received" | "queued" | "sent" | "delivered" | "read" | "failed";
  error: string;
  created_at: string;
};

export const conversationsApi = {
  list: async () => {
    const res = await api.get<
      Paginated<WhatsAppConversation> | WhatsAppConversation[]
    >("/whatsapp/conversations/");
    return Array.isArray(res.data) ? res.data : res.data.results;
  },
  messages: async (id: string) => {
    const res = await api.get<WhatsAppChatMessage[]>(
      `/whatsapp/conversations/${id}/messages/`,
    );
    return res.data;
  },
  send: async (id: string, body: string) => {
    const res = await api.post<WhatsAppChatMessage>(
      `/whatsapp/conversations/${id}/send/`,
      { body },
    );
    return res.data;
  },
  update: async (id: string, data: { ai_enabled?: boolean }) => {
    const res = await api.patch<WhatsAppConversation>(
      `/whatsapp/conversations/${id}/`,
      data,
    );
    return res.data;
  },
  /** Removes the thread and its messages from the dashboard. Nothing is
   * deleted on the customer's phone — a new message starts a fresh thread. */
  remove: async (id: string) => {
    await api.delete(`/whatsapp/conversations/${id}/`);
  },
};
